export default "__VITE_ASSET__DJ2zlL7B__"